import type { CategoriaDocumento } from "@/lib/types";

export interface CategoriaDef {
  key: CategoriaDocumento;
  label: string;
  descripcion: string;
  accept: string;
  obligatorio: boolean;
  /** Single-file: una vez subido 1 documento, se oculta el dropzone (exactamente 1). */
  single?: boolean;
}

/**
 * Las 5 categorías del checklist FB60 (decisión 10):
 *   · 3 obligatorias (≥1 cada una) · FacturaXml, FacturaPdf, Adicional.
 *   · 2 opcionales · Evidencia, Contrato.
 *
 * Definidas como constante para que la lista cargue en un solo render
 * y los hijos no recalculen el array en cada re-render del container.
 */
export const CATEGORIAS_DOCUMENTOS: CategoriaDef[] = [
  {
    key: "FacturaXml",
    label: "Factura XML",
    descripcion: "≥1 obligatorio · solo .xml",
    accept: ".xml",
    obligatorio: true,
  },
  {
    key: "FacturaPdf",
    label: "Factura PDF",
    descripcion: "≥1 obligatorio · solo .pdf",
    accept: ".pdf",
    obligatorio: true,
  },
  {
    key: "Adicional",
    label: "Documentación Adicional",
    descripcion:
      "Uno o más archivos (≥1 obligatorio) · cada uno se clasifica con su tipo de documento · pdf, png, jpg, xml, docx, xlsx",
    accept: ".pdf,.png,.jpg,.jpeg,.xml,.docx,.xlsx",
    obligatorio: true,
  },
];

/**
 * Checklist documental del subtipo Invoice (factura extranjera): el PDF del Invoice
 * ya se cargó en el paso de Factura (PDF) (OCR), así que aquí se sube el certificado
 * de residencia fiscal (exactamente 1 · solo .pdf) y ≥1 Documentación Adicional.
 */
export const CATEGORIAS_DOCUMENTOS_INVOICE: CategoriaDef[] = [
  {
    key: "CertificadoResidencia",
    label: "Certificado de residencia fiscal",
    descripcion: "Un (1) archivo PDF obligatorio · certificado de residencia fiscal del proveedor extranjero.",
    accept: ".pdf",
    obligatorio: true,
    single: true,
  },
  {
    key: "Adicional",
    label: "Documentación Adicional",
    descripcion:
      "Uno o más archivos (≥1 obligatorio) · cada uno se clasifica con su tipo de documento · pdf, png, jpg, xml, docx, xlsx",
    accept: ".pdf,.png,.jpg,.jpeg,.xml,.docx,.xlsx",
    obligatorio: true,
  },
];
